import React from 'react';
import { ListLayout } from '../../../common/components/layout';
import GroupVisitsList from './list/groupVisitsList';

const GroupVisits = () => {
  return <ListLayout list={<GroupVisitsList />} size='lg' />;
};

export default GroupVisits;
